import billRequestApi from '@/api/billRequest/billRequestApi.js';
import cookie from '@/util/cookie';

export default {
	name: 'bill-request-confirm',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			confirmResp: null,
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			const confirmCode = this.$route.query.code;
			
			this.confirmResp = await billRequestApi.confirm(confirmCode);
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billRequest/billRequestConfirm.js